import {
  BooleanResult,
  Method,
  MethodCategoriesEnum,
  StaticallyTypedMethod,
  TransformerIdsEnum,
} from './internal';

export const baseMethods: Partial<Record<TransformerIdsEnum, Method>> = {
  is_defined: new StaticallyTypedMethod(MethodCategoriesEnum.PROPERTY, BooleanResult),
  is_undefined: new StaticallyTypedMethod(MethodCategoriesEnum.PROPERTY, BooleanResult),
};
